import React from 'react'
import ChangePassword from '../_Components/ChangePassword'

import { Col, Row } from 'react-bootstrap'


export default function Security({ user }) {
  return <Row className='mb-4'>
    <Col>
      <div className='lead pb-3'>Change Password</div>
      <ChangePassword user={ user }/>
    </Col>
  </Row>
}
